// extracted by mini-css-extract-plugin
module.exports = {"main_page":"StrategySettings_main_page__3IwGO","main_header":"StrategySettings_main_header__vNewp","content":"StrategySettings_content__2UovY"};